import { Cause } from "types";
import { getApi } from "./util/getApi";


const fetchCausesURL = process.env.REACT_APP_API_URL + "/undertake";
const causesApi = getApi(fetchCausesURL);

export const retrieveAllCauses = async (): Promise<Cause[]> => {
  try {
    const response = await causesApi.post("/retrieveAll");
    return response.data;
  } catch (error) {
    console.error("Error fetching causes:", error);
    throw error;
  }
};